import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { CompanyTransporterInformationDto, companyTransporterInformationValidationSchema } from 'dtos'
import { Formik } from 'formik'
import { ExplanationAccordion, GreenText } from 'components'

interface TransportInformationAddEditDialogProps {
  initialValues: CompanyTransporterInformationDto
  loading: boolean
  onClose: () => void
  onSave: (values: any) => void
  open: boolean
}

export default function TransportInformationAddEditDialog({
  initialValues,
  loading,
  onClose,
  onSave,
  open
}: TransportInformationAddEditDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validateOnChange={true}
        validateOnBlur={false}
        validationSchema={companyTransporterInformationValidationSchema}
        onSubmit={(values, formikHelpers) => {
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Transporter Information</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.transporterSCAC && errors.transporterSCAC)}
                      helperText={touched.transporterSCAC && errors.transporterSCAC}
                      label='SCAC'
                      name='transporterSCAC'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.transporterSCAC}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={loading || isSubmitting}
                      error={Boolean(touched.dotNumber && errors.dotNumber)}
                      helperText={touched.dotNumber && errors.dotNumber}
                      label='DOT Number'
                      name='dotNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.dotNumber}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`**SCAC:**
                      
A free-text field with a 25-character limit, allowing users to input the SCAC

**DOT #:**

A free-text field with a 25-character limit, allowing users to input the DOT
Number

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save any changes

**SAVE Button:**

Clicking the SAVE button will save any changes.                      

`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={loading || isSubmitting} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={loading || isSubmitting} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
